import { translateText } from "infra/translation/translate";
import DropdownComponent from "presentation/components/Shared/DropdownComponent";
import InputNumberComponent from "presentation/components/Shared/InputNumberComponent";
import { useEmployeeStore } from "presentation/stores/use-employee-store";
import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";
import { Parameter } from "domain/entities/parameter";
import "./index.css";
import { Calendar } from "primereact/calendar";
import { useTripOriginStore } from "presentation/stores/use-trip-origin-store";
import { DistanceInputFilter } from "domain/models/distance-input-filter";
import { useTripLocationsByFilter } from "presentation/hooks/use-query-distance";
import InputDateComponent from "presentation/components/Shared/InputDateComponent";
import { Tripsheet } from "domain/entities/tripsheet";
import {
  useCreateTripsheetMutation,
  useTripsheetsByFilter,
} from "presentation/hooks/use-query-tripsheet";
import { useAuthStore } from "presentation/stores/use-auth-store";
import { TripsheetInputFilter } from "domain/models/tripsheet-input-filter";
import { Toast } from "primereact/toast";
import { EMAIL } from "domain/enum/email";
import Spinner from "presentation/components/Shared/Spinner";
import { DistanceTypeEnum } from "domain/enum/distanceType";
import { useSalariesByFilter } from "presentation/hooks/use-query-salary";
import { SalaryInputFilter } from "domain/models/salary-input-filter";
import { Dialog } from "primereact/dialog";

interface ParamProps {
  isDisable: boolean;
}

interface TripsheetSettingParams {
  monthValue: number;
  variationPercentage: number;
  tripOrigin: string;
  date: Date;
}

interface FormatedTripsheets {
  month: any;
  kmValueCalculated: any;
  referenceValue: any;
  status: any;
  proportion: any;
  newProportion: any;
  settled: any,
  pendingSettlment: any,
  supportPreventionValue: any
  supportTripsValue: any
}

const TripsheetSettingForm: React.FC<ParamProps> = (params: ParamProps) => {
  const toast = useRef<Toast>(null);
  const { employee, setEmployee } = useEmployeeStore();
  const { tripOrigin, setTripOrigin } = useTripOriginStore();
  const { email: userEmployeeEmail, userPermissions } = useAuthStore();

  const [showMonthValueWarning, setShowMonthValueWarning] = useState(false);


  const [formatedTripsheets, setFormatedTripsheets] =
    useState<FormatedTripsheets[]>();

  const monthsArray = [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez",
  ];

  const {
    mutate: createTripsheetMutation,
    error: creationTripsheetError,
    isError: isCreationTripsheetError,
    isSuccess: isCreationTripsheetSuccess,
    isPending: isCreatingTripsheet,
    data: tripsheetCreated,
  } = useCreateTripsheetMutation();

  const [tripsheetParameters, setTripsheetParameters] =
    useState<TripsheetSettingParams>();

  const { data: tripsheetsData, refetch: refetchExistentTripsheets } =
    useTripsheetsByFilter({
      employeeId: employee?.id,
      year: new Date(tripsheetParameters?.date ?? "").getFullYear(),
      ignoreCanceled: true,
      sortBy: "month",
      sortOrder: "asc",
      page: 1,
      limit: 100,
    } as TripsheetInputFilter);

  const { data: tripOriginData } = useTripLocationsByFilter({
    type: DistanceTypeEnum.MAPA_KM,
    sortBy: "locationOrigin",
    sortOrder: "asc",
    page: 1,
    limit: 100,
  } as DistanceInputFilter);

  const { data: salaryData, refetch: refetchSalaryData } =
    useSalariesByFilter({
      employeeId: employee?.id
    } as SalaryInputFilter);

  useEffect(() => {
    if (tripOriginData?.data) {
      const tripOriginsMap = new Map<string, Parameter>();

      tripOriginData.data.forEach((item) => {
        const key = item.locationOrigin?.trim();
        if (key && !tripOriginsMap.has(key)) {
          tripOriginsMap.set(key, {
            value: item.locationOrigin,
            id: item.locationOrigin,
            type: "tripOrigin",
            createdAt: item.createdAt,
            modifiedAt: item.modifiedAt,
          });
        }
      });
      const uniqueTripOrigins = Array.from(tripOriginsMap.values());
      setTripOrigin(uniqueTripOrigins);
    }
  }, [tripOriginData]);

  useEffect(() => {
    if (tripsheetsData?.data) {
      let formatedTrsh: FormatedTripsheets[] = [
        {
          month: "Mês",
          kmValueCalculated: "Calculado",
          referenceValue: "Referência",
          status: "Estado",
          proportion: "Proporção Original",
          newProportion: "Proporção Final",
          settled: "Valor de Acerto Efetuado",
          pendingSettlment: "Valor de Acertos Pendentes",
          supportPreventionValue: "Valor de Prevenção",
          supportTripsValue: "Deslocações de Suporte"
        },
      ];
      for (const trsh of tripsheetsData.data) {
        formatedTrsh.push({
          month: monthsArray[trsh.month - 1],
          kmValueCalculated: trsh.kmValueCalculated,
          referenceValue: trsh.kmValueContract,
          status: trsh.status,
          proportion: trsh.proportion,
          newProportion: trsh.newProportion,
          settled: trsh.settled,
          pendingSettlment: trsh.pendingSettlment + trsh.pendingSupportTripSettlment,
          supportPreventionValue: trsh.supportPreventionValue,
          supportTripsValue: trsh.supportTripsValue
        } as FormatedTripsheets);
      }
      setFormatedTripsheets(formatedTrsh);
    }
  }, [tripsheetsData]);

  useEffect(() => {
    if (tripsheetParameters?.date) {
      refetchExistentTripsheets();
    }
  }, [tripsheetParameters]);


  useEffect(() => {
    if (salaryData?.data?.length) {
      const salaryValue = salaryData.data[0].costsAllowanceValue;

      setTripsheetParameters((prev) => {
        if (!prev) {
          return {
            monthValue: salaryValue,
            variationPercentage: 10,
            tripOrigin: "",
            date: new Date(),
          };
        }

        return prev;
      });
    }
  }, [salaryData]);



  useEffect(() => {
    if (isCreationTripsheetError) {
      let message = [];
      message.push(creationTripsheetError.message);
      message = creationTripsheetError.response.data.metadata.errors;
      console.log("message", message);
      message.map((item: string) => {
        toast.current?.show({
          severity: "error",
          summary: "Erro",
          detail: item || "Ocorreu um erro inesperado",
          life: 2000,
        });
      });
    }
  }, [creationTripsheetError, isCreationTripsheetError]);

  useEffect(() => {
    if (isCreationTripsheetSuccess) {
      const successMessage = "Tripsheets criadas com sucesso";

      toast.current?.show({
        severity: "success",
        summary: "Sucesso",
        detail: successMessage,
        life: 2000,
      });
      refetchExistentTripsheets();
    }
  }, [isCreationTripsheetSuccess, refetchExistentTripsheets]);

  const handleCancelDifferentValue = () => {
    setShowMonthValueWarning(false);
  };

  const handleContinueWithDifferentValue = async () => {

    if (tripsheetParameters) {
      const tripsheetToCreate: Tripsheet = {
        year: new Date(tripsheetParameters.date).getFullYear(),
        kmValueMonth: tripsheetParameters.monthValue,
        variation: tripsheetParameters.variationPercentage,
        locationOrigin: tripsheetParameters.tripOrigin,
        locationOriginFullString: "",
        employee: {
          id: employee?.id || "",
          name: employee?.name || "",
          address: employee?.address || "",
          complement: employee?.complement || "",
          postalCode: employee?.postalCode || "",
          city: employee?.city || "",
          country: employee?.country || ""
        },
        lastModifiedBy: userEmployeeEmail ?? EMAIL,
        month: -1,
        kmValueContract: -1,
        kmValueCalculated: -1,
        status: "",
        proportion: -1,
        newProportion: -1,
        kmValueFromLastYear: -1,
        supportPreventionValue: -1,
        supportTripsValue: -1,
        version: -1,
        settled: -1,
        pendingSettlment: -1,
        pendingSupportTripSettlment: -1
      };

      createTripsheetMutation(tripsheetToCreate);
      await refetchExistentTripsheets();
    }
    setShowMonthValueWarning(false);
  };


  const handleTripGenerate = async () => {
    if (tripsheetParameters) {
      if (!tripsheetParameters.monthValue) tripsheetParameters.monthValue = 0;

      if (tripsheetParameters?.monthValue !== salaryData?.data?.at(0)?.costsAllowanceValue) {
        setShowMonthValueWarning(true);
        return;
      }
      else {
        handleContinueWithDifferentValue();
      }
    }
  };

  return (
    <div>
      {isCreatingTripsheet && <Spinner />}

      {!isCreatingTripsheet && (
        <div className="default-grid header-spacing">
          <div className="default-1-col remove-padding">
            <InputDateComponent
              label="Data"
              fieldName="date"
              currentObject={tripsheetParameters}
              getValue={tripsheetParameters?.date}
              setValue={setTripsheetParameters}
              view="year"
              dateFormat="yy"
            />
          </div>
          <div className="default-1-col remove-padding">
            <InputNumberComponent
              label={`Variação (em %)`}
              fieldName="variationPercentage"
              currentObject={tripsheetParameters}
              getValue={tripsheetParameters?.variationPercentage ?? 0}
              setValue={setTripsheetParameters}
              isDisable={true}
            />
          </div>
          <div className="default-1-col remove-padding">
            <InputNumberComponent
              label={`Valor mensal (€)`}
              fieldName="monthValue"
              currentObject={tripsheetParameters}
              getValue={tripsheetParameters?.monthValue}
              setValue={setTripsheetParameters}
              allowDecimals
            />
          </div>
          {/* <div className="default-1-col remove-padding">
            <DropdownComponent
              options={tripOrigin}
              label={`Local de origem`}
              fieldName="tripOrigin"
              currentObject={tripsheetParameters}
              getValue={tripsheetParameters?.tripOrigin ?? ""}
              setValue={setTripsheetParameters}
            />
          </div> */}
          <div className="default-4-cols remove-padding button-align">
            <Button
              label={"Calcular"}
              onClick={handleTripGenerate}
              className="button-size"
              disabled={
                !(
                  tripsheetParameters?.date &&
                  // tripsheetParameters?.tripOrigin &&
                  tripsheetParameters?.variationPercentage
                )
              }
            />
          </div>

          {tripsheetsData?.data?.length && tripsheetsData?.data?.length > 0 && (
            <div className="default-4-cols remove-padding">
              Cálculo mensal:
              <table width={"100%"} className="summary-table">
                <thead>
                  <tr>
                    {formatedTripsheets?.map((item) => (
                      <th key={item.month}>{item.month}</th>
                    ))}
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {formatedTripsheets?.map((item, index) =>
                      index === 0 ? (
                        <td key={item.month}>
                          <strong>{item.kmValueCalculated}</strong>
                        </td>
                      ) : (
                        <td key={item.month}>
                          {(item.kmValueCalculated + item.supportTripsValue).toFixed(2)} €
                        </td>
                      )
                    )}
                    <td>
                      {formatedTripsheets
                        ?.slice(1)
                        .reduce((acc, curr) => acc + curr.kmValueCalculated + curr.supportTripsValue, 0)
                        .toFixed(2)} €
                    </td>
                  </tr>
                  <tr>
                    {formatedTripsheets?.map((item, index) =>
                      index === 0 ? (
                        <td key={item.month}>
                          <strong>{item.referenceValue}</strong>
                        </td>
                      ) : (
                        <td key={item.month}>
                          {item.referenceValue.toFixed(2)} €
                        </td>
                      )
                    )}
                    <td>
                      {formatedTripsheets
                        ?.slice(1)
                        .reduce((acc, curr) => acc + curr.referenceValue, 0)
                        .toFixed(2)} €
                    </td>
                  </tr>
                  <tr>
                    {formatedTripsheets?.map((item, index) =>
                      index === 0 ? (
                        <td key={item.month}>
                          <strong>{item.settled}</strong>
                        </td>
                      ) : (
                        <td key={item.month}>
                          {item.settled.toFixed(2)} €
                        </td>
                      )
                    )}
                    <td>
                      -
                    </td>
                  </tr>
                  <tr>
                    {formatedTripsheets?.map((item, index) =>
                      index === 0 ? (
                        <td key={item.month}>
                          <strong>{item.pendingSettlment}</strong>
                        </td>
                      ) : (
                        <td key={item.month}>
                          {(item.pendingSettlment).toFixed(2)} €
                        </td>
                      )
                    )}
                    <td>
                      -
                    </td>
                  </tr>
                  <tr>
                    {formatedTripsheets?.map((item, index) =>
                      index === 0 ? (
                        <td key={item.month}>
                          <strong>{item.proportion}</strong>
                        </td>
                      ) : (
                        <td key={item.month}>
                          {item.proportion.toFixed(2)} %
                        </td>
                      )
                    )}
                    <td>
                      {
                        ((formatedTripsheets
                          ?.slice(1)
                          .reduce((acc, curr) => acc + curr.proportion, 0) || 0) / ((formatedTripsheets?.length || 12) - 1)
                        ).toFixed(2)
                      } %

                    </td>
                  </tr>

                  <tr>
                    {formatedTripsheets?.map((item, index) =>
                      index === 0 ? (
                        <td key={item.month}>
                          <strong>{item.newProportion}</strong>
                        </td>
                      ) : (
                        <td key={item.month}>
                          {item.newProportion.toFixed(2)} %
                        </td>
                      )
                    )}
                    <td>
                      {
                        ((formatedTripsheets
                          ?.slice(1)
                          .reduce((acc, curr) => acc + curr.newProportion, 0) || 0) / ((formatedTripsheets?.length || 12) - 1)
                        ).toFixed(2)
                      } %

                    </td>
                  </tr>

                  <tr>
                    {formatedTripsheets?.map((item, index) =>
                      index === 0 ? (
                        <td key={item.month}>
                          <strong>{item.supportPreventionValue}</strong>
                        </td>
                      ) : (
                        <td key={item.month}>
                          {item.supportPreventionValue.toFixed(2)} €
                        </td>
                      )
                    )}
                    <td>
                      {formatedTripsheets
                        ?.slice(1)
                        .reduce((acc, curr) => acc + curr.supportPreventionValue, 0)
                        .toFixed(2)} €
                    </td>
                  </tr>
                  <tr>
                    {formatedTripsheets?.map((item, index) =>
                      index === 0 ? (
                        <td key={item.month}>
                          <strong>{item.supportTripsValue}</strong>
                        </td>
                      ) : (
                        <td key={item.month}>
                          {item.supportTripsValue.toFixed(2)} €
                        </td>
                      )
                    )}
                    <td>
                      {formatedTripsheets
                        ?.slice(1)
                        .reduce((acc, curr) => acc + curr.supportTripsValue, 0)
                        .toFixed(2)} €
                    </td>
                  </tr>
                  <tr>
                    {formatedTripsheets?.map((item, index) =>
                      index === 0 ? (
                        <td key={item.month}>
                          <strong>{item.status}</strong>
                        </td>
                      ) : (
                        <td key={item.month}>{item.status}</td>
                      )
                    )}
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      <Dialog
        header="Confirmação"
        visible={showMonthValueWarning}
        modal
        closable={false}
        style={{ width: "450px" }}
        onHide={handleCancelDifferentValue}
        footer={
          <div className="flex justify-content-end gap-2">
            <Button
              label="Cancelar"
              className="p-button-text"
              onClick={handleCancelDifferentValue}
            />
            <Button
              label="Continuar"
              onClick={handleContinueWithDifferentValue}
              autoFocus
            />
          </div>
        }
      >
        <p>
          O valor mensal definido (
          <strong>{tripsheetParameters?.monthValue} €</strong>) é diferente do valor atual que consta no
          salário do colaborador (
          <strong>{salaryData?.data?.at(0)?.costsAllowanceValue} €</strong>).
        </p>
      </Dialog>



      <Toast ref={toast} position="bottom-right" />
    </div>
  );
};
export default TripsheetSettingForm;
